// shared-components/features/admin/AdminNavItem.jsx

import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { THEME } from "@shared/constants/designSystem";

export const AdminNavItem = ({ to, icon: Icon, children, badge }) => {
  return (
    <NavLink
      to={to}
      className={({ isActive }) => `
        flex items-center justify-between px-4 py-3 sm:py-2 text-base sm:text-sm rounded-md transition-colors duration-200
        ${
          isActive
            ? `${THEME.COLORS.BG.PRIMARY} ${THEME.COLORS.TEXT.ON_PRIMARY}`
            : `${THEME.COLORS.TEXT.DEFAULT} hover:bg-gray-100 dark:hover:bg-gray-800`
        }
      `}
    >
      {({ isActive }) => (
        <>
          <div className="flex items-center">
            {Icon && (
              <Icon
                className={`w-5 h-5 mr-3 ${isActive ? "text-current" : THEME.COLORS.TEXT.MUTED}`}
              />
            )}
            {children}
          </div>
          {badge && (
            <span className="inline-flex items-center px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
              {badge}
            </span>
          )}
        </>
      )}
    </NavLink>
  );
};

AdminNavItem.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  badge: PropTypes.string,
};
